import { render } from "./box-line.vue?vue&type=template&id=c3be1d18"
import script from "./box-line.vue?vue&type=script&lang=js"
export * from "./box-line.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__